import { RiskExposureMode } from "./RiskExposure.types";

// The single shared rendering of a captured exposure value — an amount with the tenant currency in financial
// mode, "n / upper bound" in scale mode — so every dialog and card shows exposure identically. Returns null
// when nothing was captured (callers hide the row entirely).
export function formatExposureValue(
    exposureValue: number | null,
    exposureMode: RiskExposureMode,
    exposureCurrencyCode: string | null,
    exposureScaleUpperBound: number | null,
    translateNumber: (value: number, options?: Intl.NumberFormatOptions) => string
): string | null {
    if (exposureValue == null || exposureMode === RiskExposureMode.None) return null;
    return exposureMode === RiskExposureMode.Financial
        ? `${translateNumber(exposureValue)} ${exposureCurrencyCode}`
        : // Scale values are ordinal levels, but a summed view can average them, so cap the fraction digits to
          // match the exposure banner rather than spilling a long repeating decimal.
          `${translateNumber(exposureValue, { maximumFractionDigits: 2 })} / ${exposureScaleUpperBound}`;
}

// Estimated cost is money in every mode, so it always renders with the tenant currency (never the scale form)
// and only blanks out when unset. Shared by the overview cost columns.
export function formatExposureCost(value: number | null, exposureCurrencyCode: string | null, translateNumber: (value: number) => string): string | null {
    return value != null ? `${translateNumber(value)} ${exposureCurrencyCode ?? ""}` : null;
}
